export const SELECTED_CATEGORY_ID_KEY = 'selectedCategoryId';

export const DEFAULT_TRENDS = {
	period: 'weekly',
	win_rate: {
		current: 60,
		previous: 0,
		delta: 60,
	},
	avg_pnl: {
		current: 10,
		previous: 0,
		delta: 10,
	},
	trade_count: {
		current: 5,
		previous: 0,
		delta: 5,
	},
};

/** Icon tile colours for the profile insight rows (highlights, market performance). */
export const PROFILE_INSIGHT_TONE_CLASSES = {
	green: 'border-[rgba(12,142,71,0.4)] bg-[rgba(12,142,71,0.16)] text-[#0C8E47]',
	amber: 'border-[rgba(240,170,40,0.45)] bg-[rgba(255,196,71,0.18)] text-[#D4920B]',
	blue: 'border-[rgba(42,99,232,0.4)] bg-[rgba(42,99,232,0.16)] text-[#2A63E8]',
	red: 'border-[rgba(217,59,59,0.4)] bg-[rgba(217,59,59,0.14)] text-[#D93B3B]',
};
